import { registerEnglishCapabilities } from '../../apps/english/capabilities';

/**
 * 平台能力装配清单（src/index.tsx 启动时调用一次）：谁出现在
 * 这里，谁的能力就对全平台可用。
 *
 * 「禁用」某个 app 的能力 = 删掉对应注册调用——消费方查不到
 * 能力，相关入口自动收起（如 notebook 右键查词）。dock / 启动器
 * 的应用入口另在 `apps/home/registry.ts` 登记：入口与能力是两层
 * 决定，可以只下线能力而保留入口（反之亦然）。
 */
export function loadPlatformCapabilities(): void {
  registerEnglishCapabilities();
}
